export default "__VITE_ASSET__B60ZHW2u__"